import json from './sprite.js';

export default {
    handle: 'es_SPT12-Candy-Jar',
    label: 'es_SPT12-Candy-Jar',
    json,
};
